import { DeliveryService, PaymentService } from '@/services'

export default {
  computed: {
    shopFreeAmount() {
      return this.$store.getters[`cart/freeAmount`]
    },
    shopShippingFee() {
      return this.$store.getters[`cart/shippingFee`]
    },
    prefectures() {
      return this.$store.state.master.pref
    },
    desiredDeliveryTimeZones() {
      return this.$store.state.register.desiredDeliveryTimeZone
    },
    isRequiredAdd() {
      return (
        this.$store.getters['auth/shop'].ec_line_required_flag && this.$store.getters['auth/shop'].line_channel_flag
      )
    },
  },
  methods: {
    async fetchPaymentMethods({ delivery_id, visible = true }) {
      const { data } = await PaymentService.listMethod({
        delivery_id,
        visible,
      })
      this.$store.commit('register/SET_PAYMENT_METHODS', data)

      return data
    },
    async fetchShippingMethod() {
      const { data } = await DeliveryService.deliveryMethod()
      this.$store.commit('register/SET_SHIPPING_METHODS', data)

      return data
    },

    /**
     * Init data when access page
     */
    setDisiredDeliverydays() {
      this.$store.commit('register/SET_DESIRED_DELIVERY_DAYS', this.desiredDeliveryDays)
    },

    async fetchDeliveryTimezone(shipping_method_id) {
      const { data } = await DeliveryService.deliveryMethodDetail(shipping_method_id)

      let results = [
        ...(data?.map((item) => ({
          value: item.id,
          label: item.delivery_time,
        })) || []),
      ]

      results = [
        {
          value: null,
          label: this.$t('common.unspecified'),
        },
        ...results,
      ]

      this.$store.commit('register/SET_DESIRED_DELIVERY_TIME_ZONE', results)

      return results
    },
  },
}
